var map = {
	"./school-1.jpg": "qfk2",
	"./school-2.jpg": "CEik",
	"./school-3.jpg": "L9P/",
	"./school-4.jpg": "WV6W",
	"./school-5.jpg": "+Vls",
	"./school-6.jpg": "MUJx",
	"./school-7.jpg": "sXMV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+FQe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/schools nonrecursive \.png$|\.jpg$
// module id = +FQe
// module chunks = 1